/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ComponentGroup } from '../../models/component-group';
import { ComponentGroupInput } from '../../models/component-group-input';

export interface TenantsTenantIdCatalogEntriesComponentGroupsPost$Params {
  tenantId: string;
      body: ComponentGroupInput
}

export function tenantsTenantIdCatalogEntriesComponentGroupsPost(http: HttpClient, rootUrl: string, params: TenantsTenantIdCatalogEntriesComponentGroupsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ComponentGroup>> {
  const rb = new RequestBuilder(rootUrl, tenantsTenantIdCatalogEntriesComponentGroupsPost.PATH, 'post');
  if (params) {
    rb.path('tenantId', params.tenantId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ComponentGroup>;
    })
  );
}

tenantsTenantIdCatalogEntriesComponentGroupsPost.PATH = '/tenants/{tenantId}/catalog-entries/component-groups';
